import {Component, ViewChild} from '@angular/core';
import {ViewController,AlertController} from "ionic-angular";
import { FoodsProvider } from '../../../providers/foods/foods';
import {Params} from "../../params";
/**
 * Generated class for the ModalRecipesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-modal-recipes',
  templateUrl: 'modal-recipes.html',
})
export class ModalRecipesPage {
  searchQuery: string = '';
  items = [];
  money = Params.money;
  @ViewChild('input') myInput ;
  constructor(
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    public foodServ: FoodsProvider) {
    this.initializeItems();
    // if(this.items.length>10){this.items = this.items.splice(0,10);}
  }

  ngOnInit(){
    setTimeout(() => {
      this.myInput.setFocus();
      console.log('setFocus');
    },1000);
  }

  initializeItems() {
    this.items = this.foodServ.recipes;
  }

  getItems(ev: any) {
    // Reset items back to all of the items
    this.initializeItems();

    // set val to the value of the searchbar
    const val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
        (item.code.toLowerCase().indexOf(val.toLowerCase()) > -1)
      })
    }
    // if(this.items.length>10){this.items = this.items.splice(0,10);}
  }

  selectRecipe(recipe){
    const prompt = this.alertCtrl.create({
      title: 'Advertencia',
      message: "¿Está seguro de reemplazar esta receta?",
      buttons: [
        {
          text: 'No estoy seguro',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: '¡Si!',
          handler: data => {
            this.viewCtrl.dismiss({
              recipe:recipe
            })
          }
        }
      ]
    });
    prompt.present();

  }

  dismiss(){
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/days/modal-recipes/modal-recipes.ts